import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import { useAuth } from '../../context/AuthContext';
import { updateCompanyProfile } from '../../api/companyProfile';
import './MessagePage.css';

const MessagePage = () => {
  const { company, setCompany } = useAuth();
  const [text, setText] = useState(company?.broadcast_message || '');
  const [enabled, setEnabled] = useState(company?.broadcast_message_enabled || false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  const save = async (nextText, nextEnabled) => {
    setSaving(true);
    setError('');
    setSaved(false);
    try {
      const formData = new FormData();
      formData.append('broadcast_message', nextText);
      formData.append('broadcast_message_enabled', nextEnabled ? 'true' : 'false');
      const updated = await updateCompanyProfile(formData);
      setCompany(updated);
      setText(updated.broadcast_message);
      setEnabled(updated.broadcast_message_enabled);
      setSaved(true);
    } catch (err) {
      setError('Sauvegarde impossible.');
    } finally {
      setSaving(false);
    }
  };

  const handleSave = (e) => {
    e.preventDefault();
    save(text, enabled);
  };

  const handleErase = () => {
    save('', false);
  };

  return (
    <Layout>
      <p className="msg-breadcrumb">
        Ruta : <Link to="/dashboard" className="bc-link">Menu</Link>
        {' >> '}
        <Link to="/parametres" className="bc-link">Parametres</Link>
        {' >> '}
        <span className="bc-current">Message</span>
      </p>

      <div className="msg-card">
        <div className="msg-card-header">
          <span className="msg-card-title">Message</span>
        </div>
        <div className="msg-card-body">
          <form onSubmit={handleSave}>
            <div className="msg-row">
              <label className="msg-label">Texte du message</label>
              <textarea
                className="msg-textarea"
                value={text}
                onChange={(e) => { setText(e.target.value); setSaved(false); }}
                placeholder="Texte qui défilera en boucle en haut de l'app, chez toutes les banques..."
              />
            </div>

            <label className="msg-checkbox-label">
              <input
                type="checkbox"
                checked={enabled}
                onChange={(e) => { setEnabled(e.target.checked); setSaved(false); }}
              />
              Activer le message dans l'app
            </label>

            <p className="msg-hint">
              Une fois activé et sauvegardé, ce message défile en boucle en haut de l'écran
              de l'app, chez toutes les banques de la company. Décoche "Activer" pour le
              masquer sans perdre le texte, ou "Effacer" pour le vider complètement.
            </p>

            {error && <p className="msg-error">{error}</p>}
            {saved && <p className="msg-ok">Sauvegardé.</p>}

            <div className="msg-btns">
              <button type="submit" className="msg-save-btn" disabled={saving}>
                {saving ? 'Sauvegarde...' : 'Sauvegarder'}
              </button>
              <button type="button" className="msg-erase-btn" onClick={handleErase} disabled={saving}>
                Effacer
              </button>
            </div>
          </form>

          {enabled && text.trim() && (
            <div className="msg-preview">
              <p className="msg-preview-label">Aperçu (bandeau en haut de l'app) :</p>
              <div className="msg-preview-bar">{text}</div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default MessagePage;
